var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Dropdown',{attrs:{"options":_vm.options,"disabled":false,"name":"zipcode","maxItem":_vm.maxItem,"placeholder":_vm.placeholder}})
}
var staticRenderFns = []

export { render, staticRenderFns }